import { Injectable, inject } from '@angular/core';
import { IRemoteError, ISeverityHandler, SeverityHandler, TSeverityCallback, TSeverityCode } from '@partners/errors';

import { SettingsMap } from '@partners/settings';
import { takeOnce } from '@partners/utils';
import { EMPTY, tap } from 'rxjs';
import { OtpWarningComponent } from '../../../components';
import { DialogAdapter } from '../../../dialogs';
import { NavigationAdapter } from '../../../navigation';

@Injectable({
  providedIn: 'root'
})
export class AuthOtpSeverities extends SeverityHandler implements ISeverityHandler {
  override handlers: Map<TSeverityCode, TSeverityCallback>;
  private _navAdapter = inject(NavigationAdapter);
  private _dialogAdapter = inject(DialogAdapter);

  constructor() {
    super();

    this.handlers = new Map<TSeverityCode, TSeverityCallback>()

      .set('W_0086', (error: IRemoteError) => {
        this.showInputErrorDialog();
        return EMPTY;
      })
      .set('W_0544', (error: IRemoteError) => {
        this.showInputErrorDialog();
        return EMPTY;
      })
      .set('W_0545', (error: IRemoteError) => {
        this.showCancelErrorDialog(error);
        return EMPTY;
      })
      .set('W_0087', (error: IRemoteError) => {
        this.showCancelErrorDialog(error);
        return EMPTY;
      });
  }

  private showInputErrorDialog = () => {
    this._dialogAdapter.open(OtpWarningComponent);
  };

  private showCancelErrorDialog = ({ message, title }: IRemoteError) => {
    const cancelDialogRef = this._dialogAdapter.openAlert({ message, title });

    cancelDialogRef.onDismiss$
      .pipe(
        takeOnce(),
        tap((result) => {
          const { name } = SettingsMap.scanIntro();
          this._navAdapter.moveTo(name);
        })
      )
      .subscribe();
  };
}
